import React, { memo } from 'react'

import Skeleton from '@material-ui/lab/Skeleton'

const LogoGroup = ({
  src,
  classNameContainer = '',
  classNameImage = '',
  loading = false,
  alternative = 'DG',
}) => {
  return (
    <div className={`group_logo_container ${classNameContainer}`}>
      {!loading ? (
        src ? (
          <img
            className={`group_logo_image ${classNameImage}`}
            src={src}
            alt="Group logo"
          />
        ) : (
          <span className="alternative">{alternative}</span>
        )
      ) : (
        <Skeleton variant="circle" width={120} height={120} />
      )}
    </div>
  )
}

export default memo(LogoGroup)
